module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('custom-header'), _c('div', {
    staticClass: "section main-section"
  }, [_c('transition', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('a', {
    staticClass: "collapse-sidebar is-hidden-mobile",
    class: {
      'pulled': !_vm.isHiddenDesktop
    },
    on: {
      "click": function($event) {
        _vm.isHiddenDesktop = !_vm.isHiddenDesktop
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "size": "is-large",
      "icon": _vm.isHiddenDesktop ? 'keyboard_arrow_right' : 'keyboard_arrow_left'
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHiddenDesktop),
      expression: "!isHiddenDesktop"
    }],
    staticClass: "column is-2"
  }, [_c('sidebar')], 1)]), _c('section', {
    staticClass: "column main-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1), _c('custom-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ab0c74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 401
// module chunks = 56